import { createReducer, on } from '@ngrx/store';
import { sortByKeyFn } from 'app/services/utils/arrayUtils';
import * as VendorActions from './vendor.actions';
import { Vendor } from './vendor.models';

const fieldKey = 'department_name'; // Replace with the actual field key you want to sort by

// ----------------------------------------------------------------------
// @ States
// ----------------------------------------------------------------------

export interface VendorsState {
    vendors: Vendor[];
    vendor: Vendor;
    isLoading: boolean;
    error: string | null;
}

// ----------------------------------------------------------------------
// @ Initial States
// ----------------------------------------------------------------------

export const initialVendorsState: VendorsState = {
    vendors: [],
    vendor: null,
    isLoading: false,
    error: null,
};

// ----------------------------------------------------------------------
// @ Reducers
// ----------------------------------------------------------------------

// All Vendors Reducer
export const vendorsReducer = createReducer(
    initialVendorsState,

    // On Load Vendors
    on(VendorActions.loadVendors, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(VendorActions.loadVendorsSuccess, (state, { vendors }) => ({
        ...state,
        isLoading: false,
        vendors: sortByKeyFn(vendors, fieldKey),
    })),
    on(VendorActions.loadVendorsFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Load Vendors By Category Name
    on(VendorActions.loadVendorsByCategoryName, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        VendorActions.loadVendorsByCategoryNameSuccess,
        (state, { vendors }) => ({
            ...state,
            isLoading: false,
            vendors: sortByKeyFn(vendors, fieldKey),
        })
    ),
    on(VendorActions.loadVendorsByCategoryNameFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Load Single Vendor
    on(VendorActions.loadVendor, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(VendorActions.loadVendorSuccess, (state, { vendor }) => ({
        ...state,
        isLoading: false,
        vendor: vendor,
    })),
    on(VendorActions.loadVendorFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Create
    on(VendorActions.createVendor, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(VendorActions.createVendorSuccess, (state, { vendor }) => ({
        ...state,
        isLoading: false,
        vendors: sortByKeyFn([...(state.vendors || []), vendor], fieldKey),
        vendor: vendor,
    })),
    on(VendorActions.createVendorFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Update
    on(VendorActions.updateVendor, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(VendorActions.updateVendorSuccess, (state, { vendor }) => ({
        ...state,
        isLoading: false,
        vendors: sortByKeyFn(
            state.vendors.map((v) => (v.id === vendor.id ? vendor : v)),
            fieldKey
        ),

        vendor: vendor,
    })),
    on(VendorActions.updateVendorFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Delete
    on(VendorActions.deleteVendor, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(VendorActions.deleteVendorSuccess, (state, { id }) => ({
        ...state,
        isLoading: false,
        vendors: sortByKeyFn(
            state.vendors.filter((v) => v.id !== id),
            fieldKey
        ),
    })),
    on(VendorActions.deleteVendorFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    }))
);
